export default __webpack_public_path__ + "68c07e6a6581ff62d1fc2cd3d922a2a9.svg";